<template>
  <div id="echeck-app-page" class="main-page">
    <p class="app-page-title">eCheck Application</p>
    <div class="container">
      <div
        class="nav nav-pills nav-justified justify-content-center mb-0 flex-row"
        id="pills-tab"
        role="tablist"
      >
        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link"
            :class="{activeClass: selectedTab==0}"
            @click="selectedTab=0"
          >
            <i class="fas fa-fw fa-rocket"></i> Business
          </a>
          <tabCount :unFinishedField="count_unfinishedField(ownerForms,companyForms,businessForms,transactionForms,companyaddressForms)"/>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link flex-md-column"
            :class="{activeClass: selectedTab==1}"
            @click="selectedTab=1"
          >
            <i class="fas fa-fw fa-handshake"></i> Bank Info
          </a>
          <tabCount :unFinishedField="count_unfinishedField(ownershipForms,bankForms)"/>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link flex-md-colum"
            :class="{activeClass: selectedTab==2}"
            @click="selectedTab=2"
          >
            <i class="fa fa-credit-card"></i> Credit Card Info
          </a>
          <tabCount :unFinishedField="count_unfinishedField(cardForms)"/>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6">
          <a
            class="nav-link last-pill"
            :class="{activeClass: selectedTab==3}"
            @click="selectedTab=3"
          >
            <i class="fas fa-fw fa-file-alt"></i> Documentation
          </a>
          <tabCount :unFinishedField="count_unfinishedField(documentField)"/>
        </div>
      </div>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade"
          :class="{active: selectedTab==0, show: selectedTab==0}"
          id="pills-business"
          role="tabpanel"
          aria-labelledby="pills-business-tab"
        >
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Business Owner</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(ownerForms) }}/
                  {{ Object.keys(ownerForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="First Name"
                  nameclass="app-field"
                  v-model="ownerForms.first_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Last Name"
                  nameclass="app-field"
                  v-model="ownerForms.last_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Position"
                  nameclass="app-field"
                  v-model="ownerForms.position"
                />
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <phoneInputBase
                  label="Cell Phone"
                  nameclass="app-field last-field-left"
                  v-model="ownerForms.cell_phone"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <phoneInputBase
                  label="Work Phone"
                  nameclass="app-field last-field-left"
                  v-model="ownerForms.work_phone"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <phoneInputBase
                  label="Fax"
                  nameclass="app-field last-field-right"
                  v-model="ownerForms.fax_phone"
                />
              </div>
            </div>
          </div>

          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Company Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(companyForms) }}/
                  {{ Object.keys(companyForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Merchant's Legal Business Name"
                  nameclass="app-field"
                  v-model="companyForms.legal_company_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <typeBusinessInputBase
                  label="Corporation"
                  nameclass="app-field last-field-left"
                  v-model="companyForms.company_corporate_type"
                />
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <dateInputBase
                  label="Company Start Date"
                  nameclass="app-field last-field-left"
                  v-model="companyForms.company_start_date"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Tax ID / EIN"
                  nameclass="app-field last-field-right"
                  v-model="companyForms.tax_id"
                />
              </div>
            </div>
          </div>

          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Business Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(businessForms) }}/
                  {{ Object.keys(businessForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="What Type of Business Are You In? Do Not Say Sales"
                  nameclass="app-field last-field-left"
                  v-model="businessForms.company_business_type"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Business Website"
                  nameclass="app-field last-field-right"
                  v-model="businessForms.company_web"
                />
              </div>
            </div>
          </div>
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Your Business Transaction Details</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(transactionForms) }}/
                  {{ Object.keys(transactionForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <moneyInputBase
                  label="Estimated Monthly Volume"
                  placeholder="Please Enter Numeric Value"
                  nameclass="app-field"
                  v-model="transactionForms.estimated_monthly_volume"
                />
                <moneyInputBase
                  placeholder="Please Enter Numeric Value"
                  label="Estimated High Check Amount"
                  nameclass="app-field last-field-left"
                  v-model="transactionForms.estimated_low_check_amount"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <moneyInputBase
                  label="Estimated Low Check Amount"
                  placeholder="Please Enter Numeric Value"
                  nameclass="app-field"
                  v-model="transactionForms.estimated_high_check_amount"
                />
              </div>
            </div>
          </div>
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Business Address</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(companyaddressForms) }}/
                  {{ Object.keys(companyaddressForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Street Address"
                  nameclass="app-field"
                  v-model="companyaddressForms.company_address"
                />
                <stateInputBase
                  label="State"
                  nameclass="app-field last-field-left"
                  v-model="companyaddressForms.company_state"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="City"
                  nameclass="app-field"
                  v-model="companyaddressForms.company_city"
                />
                <numberInputBase
                  label="Zip / Postal Code"
                  nameclass="app-field last-field-right"
                  v-model="companyaddressForms.company_zip_portal"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-bank" role="tabpanel" aria-labelledby="pills-bank-tab"
          :class="{active: selectedTab==1, show: selectedTab==1}"
        >
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Ownership Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(ownershipForms) }}/
                  {{ Object.keys(ownershipForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Owner Name"
                  nameclass="app-field"
                  v-model="ownershipForms.owner_fullname"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <emailInputBase
                  label="Email"
                  nameclass="app-field last-field-left"
                  v-model="ownershipForms.email"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Title"
                  nameclass="app-field last-field-left"
                  placeholder="CEO,Partner,Etc"
                  v-model="ownershipForms.title"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="SSN"
                  nameclass="app-field last-field-right"
                  v-model="ownershipForms.ssn"
                />
              </div>
            </div>
          </div>
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Bank Account Information (For Deposits)</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(bankForms) }}/
                  {{ Object.keys(bankForms).length }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Bank/Financial Institution Name"
                  nameclass="app-field"
                  v-model="bankForms.bank_name"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Routing #"
                  nameclass="app-field"
                  v-model="bankForms.routing"
                />
              </div>
            </div>
            <numberInputBase label="Account #" nameclass="app-field" v-model="bankForms.account" />
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Address on Bank Account"
                  nameclass="app-field"
                  v-model="bankForms.bank_address"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="State"
                  nameclass="app-field last-field-left"
                  v-model="bankForms.bank_state"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase label="City" nameclass="app-field last-field-left" v-model="bankForms.bank_city" />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Zip / Postal Code"
                  nameclass="app-field last-field-right"
                  v-model="bankForms.bank_zip"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-card" role="tabpanel" aria-labelledby="pills-card-tab"
          :class="{active: selectedTab==2, show: selectedTab==2}"
        >
          <div class="app-section">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                <p class="app-section-title">Bank Credit and Debit Card Information</p>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <p class="fields-completed-count">
                  {{ countNull(cardForms ) }}/
                  {{ Object.keys(cardForms).length }}
                </p>
              </div>
            </div>
            <textInputBase
              label="Name on the Card"
              nameclass="app-field"
              v-model="cardForms.card_name"
            />
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase
                  label="Billing Address For the Card"
                  nameclass="app-field"
                  v-model="cardForms.billing_address"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <stateInputBase
                  label="State"
                  nameclass="app-field last-field-left"
                  v-model="cardForms.billing_state"
                />
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <textInputBase label="City" nameclass="app-field last-field-left" v-model="cardForms.billing_city" />
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                  label="Zip / Postal Code"
                  nameclass="app-field last-field-right"
                  v-model="cardForms.billing_zip"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          :class="{active: selectedTab==3, show: selectedTab==3}"
          id="pills-documentation"
          role="tabpanel"
          aria-labelledby="pills-documentation-tab"
        >
          <documentationBase ref="document" />
        </div>
      </div>
    </div>
    <div class="container merchant-app-save text-center">
      <button class="purple-btn" @click="save" :disabled="loading==true">Save</button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import store from "@/store/store";
$(document).ready(function() {
  $(".nav-link").click(function() {
    $(".nav-link").removeClass("active");
  });
});
import helper from '@/helper/helper';
import tabCount from "../components/display/tabCount";
import {
  textInputBase,
  transInputBase,
  emailInputBase,
  phoneInputBase,
  numberInputBase,
  moneyInputBase,
  percentInputBase,
  stateInputBase,
  zoneInputBase,
  operateInputBase,
  typeBusinessInputBase,
  dateInputBase,
  choicesInputBase,
  crediCardInputBase,
  cartInputBase,
  documentationBase
} from "../components/forms/baseForms";
export default {
  mixins: [helper],
  components: {
    textInputBase,
    emailInputBase,
    phoneInputBase,
    numberInputBase,
    moneyInputBase,
    percentInputBase,
    stateInputBase,
    zoneInputBase,
    operateInputBase,
    typeBusinessInputBase,
    dateInputBase,
    choicesInputBase,
    transInputBase,
    crediCardInputBase,
    cartInputBase,
    documentationBase,
    tabCount
  },
  computed: {
    appCode () {
      return this.$store.state.appCode?this.$store.state.appCode:this.$route.params.key
    },
    documentField () {
      return this.$store.state.documentField
    },
  },
  data() {
    return {
     
      loading: false,
      requirementForms: {
        company_id: null,
        company_app: null,
        owner_id: null,
        bank_id: null,
        card_id: null
      },
      cardForms: {
        card_name: null,
        billing_address: null,
        billing_city: null,
        billing_zip: null,
        billing_state: null
      },
      bankForms: {
        bank_name: null,
        routing: null,
        account: null,
        bank_address: null,
        bank_city: null,
        bank_zip: null,
        bank_state: null
      },
      ownerForms: {
        first_name: null,
        last_name: null,
        position: null,
        work_phone: null,
        cell_phone: null,
        fax_phone: null
      },
      ownershipForms: {
        owner_fullname: null,
        email: null,
        title: null,
        ssn: null
      },
      companyForms: {
        legal_company_name: null,
        company_corporate_type: null,
        company_start_date: null,
        tax_id: null
      },
      businessForms: {
        company_web: null,
        company_business_type: null
      },
      transactionForms: {
        estimated_monthly_volume: null,
        estimated_low_check_amount: null,
        estimated_high_check_amount: null
      },
      companyaddressForms: {
        company_address: null,
        company_city: null,
        company_zip_portal: null,
        company_state: null
      },
      selectedTab: 0
    };
  },
  methods: {
    set_activeTab(){
      var tab_status = [
        this.count_unfinishedField(this.ownerForms,this.companyForms,this.businessForms,this.transactionForms,this.companyaddressForms),
        this.count_unfinishedField(this.ownershipForms,this.bankForms),
        this.count_unfinishedField(this.cardForms),
        this.count_unfinishedField(this.documentField)
      ]
      for (var index in tab_status){
        if (tab_status[index] != 0){
          this.selectedTab=index
          break
        }
       
      }
    },
     countNull(obj) {
        let result = 0;
        for (let i in obj) {
          if (obj[i] && obj[i] != null) {
            result++;
          }
        }
        return result;
      },
    get_totalfield(){
      var ownerForms = this.countNull(this.ownerForms)
      var companyForms = this.countNull(this.companyForms)
      var businessForms = this.countNull(this.businessForms)
      var transactionForms = this.countNull(this.transactionForms)
      var companyaddressForms = this.countNull(this.companyaddressForms)
      var ownershipForms = this.countNull(this.ownershipForms)
      var bankForms = this.countNull(this.bankForms)
      var cardForms = this.countNull(this.cardForms)
      var docField = this.docVal()
      var total = ownerForms+companyForms+
                  businessForms+
                  transactionForms+
                  companyaddressForms+
                  ownershipForms+
                  cardForms+
                  bankForms+
                  docField
      return total

    },
    docVal: function(){
      var val =this.$refs.document;
     var vals = val.get_filledField();
     return vals
    },
    get_company() {
      Axios.get(`apps/echeck/${this.appCode}/`)
        .then(response => {
          if (response.status == 200) {
            this.requirementForms.company_id = response.data.id;
            this.requirementForms.company_app = response.data.app;
            this.companyForms.legal_company_name =
              response.data.legal_company_name;
            this.companyForms.company_start_date =
              response.data.company_start_date;
            this.companyForms.tax_id = response.data.tax_id;
            this.companyForms.company_corporate_type =
              response.data.company_corporate_type;
            this.businessForms.company_web = response.data.company_web;
            this.businessForms.company_business_type =
              response.data.company_business_type;
            this.transactionForms.estimated_monthly_volume =
              response.data.estimated_monthly_volume;
            this.transactionForms.estimated_low_check_amount =
              response.data.estimated_low_check_amount;
            this.transactionForms.estimated_high_check_amount =
              response.data.estimated_high_check_amount;
            this.companyaddressForms.company_address =
              response.data.company_address;
            this.companyaddressForms.company_city = response.data.company_city;
            this.companyaddressForms.company_zip_portal =
              response.data.company_zip_portal;
            this.companyaddressForms.company_state =
              response.data.company_state;

            this.get_owner();
            this.get_bank();
            this.get_card();
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    get_owner() {
      Axios.get(`apps/echeck/${this.requirementForms.company_id}/owner/`)
        .then(response => {
          if (response.status == 200) {
            this.requirementForms.owner_id = response.data.id;
            this.ownerForms.first_name = response.data.first_name;
            this.ownerForms.last_name = response.data.last_name;
            this.ownerForms.work_phone = response.data.work_phone;
            this.ownerForms.cell_phone = response.data.cell_phone;
            this.ownerForms.fax_phone = response.data.fax_phone;
            this.ownerForms.position = response.data.position;

            this.ownershipForms.owner_fullname = response.data.owner_fullname;
            this.ownershipForms.email = response.data.email;
            this.ownershipForms.title = response.data.title;
            this.ownershipForms.ssn = response.data.ssn;
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    get_bank() {
      Axios.get(`apps/echeck/${this.requirementForms.company_id}/bank/`)
        .then(response => {
          if (response.status == 200) {
            this.requirementForms.bank_id = response.data.id;
            this.bankForms.bank_name = response.data.bank_name;
            this.bankForms.routing = response.data.routing;
            this.bankForms.account = response.data.account;
            this.bankForms.bank_address = response.data.bank_address;
            this.bankForms.bank_city = response.data.bank_city;
            this.bankForms.bank_zip = response.data.bank_zip;
            this.bankForms.bank_state = response.data.bank_state;
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    get_card() {
      Axios.get(`apps/echeck/${this.requirementForms.company_id}/card/`)
        .then(response => {
          if (response.status == 200) {
            this.requirementForms.card_id = response.data.id;
            this.cardForms.card_name = response.data.card_name;
            this.cardForms.billing_address = response.data.billing_address;
            this.cardForms.billing_city = response.data.billing_city;
            this.cardForms.billing_zip = response.data.billing_zip;
            this.cardForms.billing_state = response.data.billing_state;
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    put_owner() {
      let data = {
        first_name: this.ownerForms.first_name,
        last_name: this.ownerForms.last_name,
        position: this.ownerForms.position,
        work_phone: this.ownerForms.work_phone,
        cell_phone: this.ownerForms.cell_phone,
        fax_phone: this.ownerForms.fax_phone,
        owner_fullname: this.ownershipForms.owner_fullname,
        email: this.ownershipForms.email,
        title: this.ownershipForms.title,
        ssn: this.ownershipForms.ssn,
        company: this.requirementForms.company_id
      };
      Axios.put(`apps/echeck/${this.requirementForms.owner_id}/owner/`, data)
        .then(response => {
          if (response.status == 200) {
            // console.log("owner saved");
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    put_card() {
      let data = {
        card_name: this.cardForms.card_name,
        billing_address: this.cardForms.billing_address,
        billing_city: this.cardForms.billing_city,
        billing_zip: this.cardForms.billing_zip,
        billing_state: this.cardForms.billing_state,
        company: this.requirementForms.company_id
      };
      Axios.put(`apps/echeck/${this.requirementForms.card_id}/card/`, data)
        .then(response => {
          if (response.status == 200) {
            // console.log("card saved");
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    put_bank() {
      let data = {
        bank_name: this.bankForms.bank_name,
        routing: this.bankForms.routing,
        account: this.bankForms.account,
        bank_address: this.bankForms.bank_address,
        bank_city: this.bankForms.bank_city,
        bank_zip: this.bankForms.bank_zip,
        bank_state: this.bankForms.bank_state,
        company: this.requirementForms.company_id
      };
      Axios.put(`apps/echeck/${this.requirementForms.bank_id}/bank/`, data)
        .then(response => {
          if (response.status == 200) {
            // console.log("bank saved");
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    save_docs: function() {
      var save = this.$refs.document;
      save.put_document();
    },
    save() {
      this.save_button_start();
      let data = {
        app: this.appCode,
        legal_company_name: this.companyForms.legal_company_name,
        company_start_date: this.companyForms.company_start_date,
        tax_id: this.companyForms.tax_id,
        company_corporate_type: this.companyForms.company_corporate_type,
        company_web: this.businessForms.company_web,
        company_business_type: this.businessForms.company_business_type,
        estimated_monthly_volume: this.transactionForms
          .estimated_monthly_volume,
        estimated_low_check_amount: this.transactionForms
          .estimated_low_check_amount,
        estimated_high_check_amount: this.transactionForms
          .estimated_high_check_amount,
        company_address: this.companyaddressForms.company_address,
        company_city: this.companyaddressForms.company_city,
        company_zip_portal: this.companyaddressForms.company_zip_portal,
        company_state: this.companyaddressForms.company_state
      };
      Axios.put(`apps/echeck/${this.appCode}/`, data).then(response => {
        if (response.status == 200) {
          this.put_owner();
          this.put_card();
          this.put_bank();
          this.save_docs();
          var appdata = {
              appcode:this.appCode,
              dba:this.companyForms.legal_company_name,
              completed_field:this.get_totalfield()
            }
            this.$store.dispatch("update_app",appdata);
          setTimeout(() => this.save_button_end(), 3000);
         if(this.selectedTab!=3){
            setTimeout(() => {this.toast_saved(),this.selectedTab++,window.scrollTo(0,0);}, 3000);
            }else{
            setTimeout(() => this.$router.go(), 3500);
            }
        }
      });
    },
    save_button_start() {
      this.loading = true;
      $(".merchant-app-save .purple-btn").html(
        'Saving <i class="fas fa-circle-notch fa-spin"></i>'
      );
    },
    save_button_end() {
      this.loading = false;
      $(".merchant-app-save .purple-btn").html("Save");
    },
    toast_saved() {
      this.$bvToast.toast(`Form saved!`, {
        toaster: "b-toaster-bottom-full",
        autoHideDelay: 2000,
        bodyClass: "toast-saved",
        noCloseButton: true
      });
    }
  },
  created() {
    if (store.state.accessToken) {
      Axios.interceptors.request.use(function(config) {
        config.headers.Authorization = `Bearer ${store.state.accessToken}`;

        return config;
      });
    } else {
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    this.get_company();
    setTimeout(()=>this.set_activeTab(),2000)

  }
};
</script>